import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-page-limit-label',
  templateUrl: './page-limit-label.component.html',
  styleUrls: ['./page-limit-label.component.scss'],
})
export class PageLimitLabelComponent implements OnInit {
  @Input()
  availableLimits: number[];
  @Input()
  currentLimit: number;
  @Input()
  allAvailable: boolean;
  @Input()
  isList: boolean = false;
  @Output()
  limitEmitter: EventEmitter<any>;

  constructor() {
    this.limitEmitter = new EventEmitter<any>();
    this.availableLimits = environment.availableLimits;
    this.currentLimit = environment.availableLimits[0];
  }

  ngOnInit() {}

  onLimitClick(limit: any) {
    this.currentLimit = limit;
    this.limitEmitter.emit(this.currentLimit);
  }
}
